import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom"
import {Tooltip, Checkbox, Button} from "antd"

class TableTemplate extends Component {
    render() {
        const {
            data,
            loading,
            error,
            label,
            bulkLoading,
            enableEmbroideryBulk,
            selectedEmbroiderySkus = [],
            onToggleEmbroiderySku,
            onToggleAllEmbroiderySkus,
            onBulkCreateEmbroideryBatches,
        } = this.props

        const embroiderySkus = (data || []).filter(i => i.production_process && i.production_process.name === 'Thêu')
        const allEmbroiderySelected = enableEmbroideryBulk && embroiderySkus.length > 0
            && embroiderySkus.every(i => selectedEmbroiderySkus.includes(i.type))

        return (
            <div className="StaticsTableCreated">
                <div className="d-flex align-items-center justify-content-between">
                    <h5 style={{ minHeight: '24px' }}>{label}</h5>
                    {enableEmbroideryBulk && selectedEmbroiderySkus.length > 0 && (
                        <div className='BulkCreateEmbroidery text-right'>
                            <Button
                                type='link'
                                loading={bulkLoading}
                                disabled={bulkLoading}
                                onClick={onBulkCreateEmbroideryBatches}
                                style={{fontSize: "16px", fontWeight: 'bold'}}
                            >
                                Tạo lô thêu
                            </Button>
                        </div>
                    )}
                </div>
                <table className="table table-bordered">
                    <thead>
                    <tr>
                        <th className='text-left'>
                            <div className="d-flex justify-content-between">
                                SKU
                                {enableEmbroideryBulk && embroiderySkus.length > 0 && (
                                    <Checkbox
                                        checked={allEmbroiderySelected}
                                        onChange={(e) => onToggleAllEmbroiderySkus && onToggleAllEmbroiderySkus(e.target.checked)}
                                        className='mr-2'
                                    />
                                )}
                            </div>
                        </th>
                        <th>Số lượng</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        loading === null && !!error && error.length > 0 && <tr>
                            <td colSpan={2} className='text-danger'>{error}</td>
                        </tr>
                    }

                    {
                        loading && <tr>
                            <td colSpan={2}>Loading...</td>
                        </tr>
                    }

                    {
                        !!data && data.length > 0 && data.map((item, index) =>
                            <tr key={index} style={item.dateFullyDone ? {background:'rgba(223, 31, 31, 0.1)'} : {}}>
                                <td className='SKU text-left' style={item.dateFullyDone ? {color:'#DF1F1F'} : {}}>
                                    <div className="d-flex justify-content-between">
                                        {item.type}
                                        {enableEmbroideryBulk && item.production_process && item.production_process.name === 'Thêu' && (
                                            <Checkbox
                                                checked={selectedEmbroiderySkus.includes(item.type)}
                                                onChange={(e) => onToggleEmbroiderySku && onToggleEmbroiderySku(item.type, e.target.checked)}
                                                className='mr-2'
                                            />
                                        )}
                                    </div>
                                </td>
                                <td className='Quantity'>
                                    <div className="quantity-detail">
                                        <Tooltip
                                            title={`Số lượng items của ${item.type} đã xử lý xong nhưng chưa tạo lô.`}>
                                            <Link
                                                to={{
                                                    pathname: "/",
                                                    search: `?type=${item.type}&production_status=unprinted&status=fully-done`
                                                }}
                                                target='_blank'
                                                style={item.dateFullyDone ? {color:'#DF1F1F'} : {}}
                                            >
                                                {item.total}
                                            </Link>
                                        </Tooltip>

                                        <div className='quantity-action'>
                                            {['THANK_CARD', 'BRAND_KIT'].includes(item.type) ? 
                                            <Link to={{
                                                pathname: "/list-unpush-kit-card",
                                                state: { type: item.type }
                                            }} className="detail-link">Detail</Link> : ''}

                                            {item.production_process && item.production_process.name === 'Thêu'? 
                                            <Link to={{
                                                pathname: "/list-unpush-embroidery",
                                                state: { type: item.type }
                                            }} className="detail-link">Detail</Link> : '' }
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )
                    }

                    {
                        !error && !loading && data.length === 0 && <tr>
                            <td colSpan={2}>No data</td>
                        </tr>
                    }
                    </tbody>
                </table>
            </div>
        )
    }
}

TableTemplate.propTypes = {
    data: PropTypes.array.isRequired,
    loading: PropTypes.any,
    error: PropTypes.string,
    enableEmbroideryBulk: PropTypes.bool,
    selectedEmbroiderySkus: PropTypes.array,
    onToggleEmbroiderySku: PropTypes.func,
    onToggleAllEmbroiderySkus: PropTypes.func,
}

export default TableTemplate
